import { NodoDto } from "@/api";
import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { Icon } from "@mui/material";
import moment from "moment";
import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";

function PosizioneNodo({
  nodo,
  big = false,
  showUltimoNodo = false,
  color,
  showDate = false,
}: {
  nodo: NodoDto;
  big?: boolean;
  showUltimoNodo?: boolean;
  color?: string;
  showDate?: boolean;
}) {
  const { t } = useTranslation();
  const breadcrumbs = nodo.breadcrumbs;
  const trasferimento = breadcrumbs && breadcrumbs[breadcrumbs.length - 1];
  const dateString =
    trasferimento &&
    getDateString(trasferimento.arco.da, trasferimento.arco.a, t);

  return (
    <Box display="flex" flexDirection="column">
      {breadcrumbs && (
        <Typography
          variant={big ? undefined : "caption"}
          color={big ? undefined : "text"}
          fontWeight="regular"
          sx={{ display: "inline-flex", flexWrap: "wrap", color }}
        >
          {breadcrumbs.map((crumb, index) => {
            return (
              <Fragment key={crumb.nodo.id}>
                {index > 0 && <Separator />}
                {crumb.nodo.nome}
              </Fragment>
            );
          })}

          {showUltimoNodo && (
            <Fragment>
              {breadcrumbs && breadcrumbs.length > 0 && <Separator />}
              {nodo.nome}
            </Fragment>
          )}
        </Typography>
      )}

      {showDate && dateString && (
        <Typography variant="caption" color="text" sx={{ mt: 0.5 }}>
          {dateString}
        </Typography>
      )}
    </Box>
  );
}

export default PosizioneNodo;

function Separator() {
  return <Icon sx={{ mx: 0.5 }}>arrow_forward</Icon>;
}

function getDateString(
  da: string | null | undefined,
  a: string | null | undefined,
  t: (key: string, options?: Record<string, string>) => string
): string | null {
  const daString = da ? moment(da).format("DD/MM/YYYY") : null;
  const aString = a ? moment(a).format("DD/MM/YYYY") : null;

  if (daString && aString) {
    return t("posizioneNodo.date.dalAl", { da: daString, a: aString });
  } else if (daString) {
    return t("posizioneNodo.date.dal", { da: daString });
  } else if (aString) {
    return t("posizioneNodo.date.finoAl", { a: aString });
  }
  return null;
}
